import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '@/components/TrackingDetail';
import { Container } from './Container';
import { Row } from './Row';

const LeftLink = () => (
  <Link to='/'>
    <div className='flex'>
      <img
        className='h-6 w-auto sm:h-7'
        src='/images/intertrace-logo-full.png'
        alt='Intertrace'
      />
    </div>
  </Link>
);

const Header = () => {
  return (
    <Row className='sticky left-0 top-0 z-50 w-full shrink-0 bg-banner py-6 shadow-md'>
      <Container className='w-full'>
        <Row className='justify-between' isCentered>
          <LeftLink />
          <LanguageSwitcher variant='header' />
        </Row>
      </Container>
    </Row>
  );
};

export { Header };
